import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, ModalController, LoadingController, ViewController } from 'ionic-angular';
import { CuentasPorCobrarProvider } from '../../providers/cuentas-por-cobrar/cuentas-por-cobrar'
import { CajaProvider } from '../../providers/caja/caja'
import { File } from '@ionic-native/file';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { UtilsProvider } from '../../providers/utils/utils'
import { AuthService } from '../../providers/auth-service';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DianProvider } from '../../providers/dian/dian';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { State } from '../../store/app.reducer'
import { Store } from '@ngrx/store';
import { UtilsRedux } from '../../providers/redux/utils/utils';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { ChangeDetectorRef } from '@angular/core';

type AOA = any[][];
@IonicPage()
@Component({
  selector: 'page-cuentas-por-cobrar-creditos-visualizar',
  templateUrl: 'cuentas-por-cobrar-creditos-visualizar.html',
  providers: [ ClienteSelectRedux, UtilsRedux,File,InAppBrowser, AuthService, ParametrosGeneralesRedux, DianProvider ]
})

export class CuentasPorCobrarCreditosVisualizarPage {

  @Input() arrayWhereLocal: any = []
  public clientesId:any
  recibo:string = "";
  pagoTotal:boolean=false
  datosCredito = []
  datosCreditoTemporal = []
  clienteId = []
  valoresTotales = []
  valorPagado:number = 0
  valorPendiente:number = 0
  data: any[][]
  companiasId;
  bluetooth:boolean = false
  fechaPagoReal:Date
  detalle:string = ''
  comprobantePago:string = ''
  listaClientes = [];
  valoresCliente: string = 'Buscar Cliente';
  isLoading: boolean = false;
  public isButtonDisabledCliente: boolean = false;
  public isButtonDisabledPago: boolean = false;
  interesCreditos:any[] = []
  planDePagos:any[]=[]
  datacliente:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  mostrarGrid: boolean= true;
  cliente: string = ''
  planDePagosCuentaPorCobrar:any[]=[]
  calcularValoresCuentaPorCobrar:any[]=[]
  cargando: boolean = true;
  progreso: number = 0;
  resultados: any[] = [];
  factura:string = ''
  itemPlanDePagos: any = { totalPagoActual: 0 };
  mostrarPlanDePagos: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public buscarCuentasPorCobrarProvider:CuentasPorCobrarProvider,
              public servicio:CajaProvider,
              public alertControllers: AlertController,
              public file: File,private iab: InAppBrowser,
              public utils: UtilsProvider,
              public auth: AuthService,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public dian: DianProvider,
              private store:Store<State>,
              public modalControllers: ModalController
              ,public utilsRedux: UtilsRedux,
              public clienteSelectRedux: ClienteSelectRedux,
              public loadingCtrl: LoadingController,
              public viewCtrl: ViewController,
              private cdr: ChangeDetectorRef) {
                if(this.navParams.get('data')){
                  this.planDePagos = this.navParams.get('data')
                  if(this.planDePagos.length === 0) {
                    this.utils.mensajeMuestro('Plan de Pagos','No existen registros','warning')
                    this.closePlanDePagos()
                  }
                }
  }
cerrarSession() {
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

togglePlanDePagos() {
  this.mostrarPlanDePagos = !this.mostrarPlanDePagos;
}

selectPlan(totalPagoCuota: any, item: any) {
  let totalPagoCuotaNumerico
  if (isNaN(Number(totalPagoCuota))) {
    // Si no es un número, elimina comas y puntos
    // totalPagoCuotaNumerico = Number(totalPagoCuota.replace(/,/g, '').replace(/\./g, ''));
    totalPagoCuotaNumerico = Number(totalPagoCuota.replace(/\./g, '').replace(/,/g, '.'));

  } else {
    // Si ya es un número, no hacer nada
    totalPagoCuotaNumerico = Number(totalPagoCuota);
  }
  totalPagoCuota = totalPagoCuotaNumerico
  this.itemPlanDePagos.totalPagoActual = totalPagoCuotaNumerico;
  this.mostrarPlanDePagos = false; // Oculta el div flotante después de seleccionar un plan
  let nuevoItem = {
    ...item,
    totalPagoCuota:totalPagoCuota
  }
  this.viewCtrl.dismiss({ selectedPlan: totalPagoCuota, item: nuevoItem });
}

  // Función para formatear el valor con separadores de miles
  formatCurrency(value: number): string {
    return value ? value.toLocaleString('es-ES', { minimumFractionDigits: 2 }) : '';
  }


  onEditTotalPagoCuota(index: number, item: any): void {
    const editedValue = this.removeCurrencyFormat(item.totalPagoCuotaEditado);
    item.totalPagoCuota = editedValue ? parseFloat(editedValue) : item.totalPagoCuota;

    // Forzar la detección de cambios
    this.cdr.detectChanges();
  }


  // // Función para quitar separadores de miles y dejar solo el número
  removeCurrencyFormat(value: string): string {
    return value ? value.replace(/\./g, '').replace(',', '.') : '0';
  }


closePlanDePagos() {
  this.viewCtrl.dismiss();
}
selectInputContent(event: any) {
  const inputElement = event.target;
  if(inputElement && inputElement.value) {
    inputElement.setSelectionRange(0, inputElement.value.length);
  }
}

searchSimple(event: any, item: any, index: number) {
  setTimeout(() => {
    let cantidad = Number(event.target.value.replace(/,/g, '')); // Remover posibles comas previas

    // Verifica si es NaN o 0
    if (cantidad == 0 || isNaN(cantidad)) {
      return;
    }

    // Si la cantidad es negativa, conviértela en positiva
    if (cantidad < 0) {
      cantidad = Math.abs(cantidad);
    }
    item.totalPagoCuota = cantidad.toLocaleString('en-US');
    // Formatear el número con separadores de miles
    item.totalPagoCuotaEditado = cantidad.toLocaleString('en-US'); // Aquí puedes cambiar 'en-US' a tu localización preferida

    // Aquí puedes realizar cualquier otra acción que desees con la cantidad.
  }, 1000);
}

colorChange(i:any) {
  if(i=== 0) {
    return 'red'
  } else {
    return 'blue'
  }
}


}



// WEBPACK FOOTER //
// ./src/pages/cuentas-por-cobrar-creditos-visualizar/cuentas-por-cobrar-creditos-visualizar.ts